import React from 'react';
import { twMerge } from 'tailwind-merge';
type BrandMarkProps = {
  className?: string;
  labelClassName?: string;
};

/** Circular B&W emblem inspired by the Blue & White logo. */
export function BrandMark({
  className,
  labelClassName
}: BrandMarkProps) {
  return <span className={twMerge('flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gold-400/70 bg-aqua-400', className)} aria-hidden="true" data-id="element-138" data-mp="3fdbehzovo9vn">
      <span className={twMerge('font-display text-[13px] font-semibold leading-none tracking-tight text-night-900', labelClassName)} data-id="element-139" data-mp="3t6j63rcyl5dc">
        B&amp;W
      </span>
    </span>;
}